import "core-js/stable";
import "regenerator-runtime/runtime";
import { FORM_RESET_SEC, MODAL_CLOSE_SEC } from "./config.js";
import * as model from "./model.js";
import addRecipeView from "./views/addRecipeView.js";
import bookMarksView from "./views/bookmarksView.js";
import paginationView from "./views/paginationView.js";
import recipeView from "./views/recipeView.js";
import resultsView from "./views/resultsView.js";
import searchView from "./views/searchView.js";

const init = function()
{
  bookMarksView.addHandlerLoadBookmarks(controlBookmarks)
  recipeView.addHandlerRender(controlRecipes);
  recipeView.addHandlerUpdateServings(controlServings);
  recipeView.addHandlerAddBookmark(controlAddBookmark);
  searchView.addHandlerSearch(controlSearchResults);
  paginationView.addHandlerChangePage(controlPage);
  addRecipeView.addHandlerUpload(controlAddRecipe);
console.log("Welcome To Forkify");
}

const controlRecipes = async function()
{
  try {
    // * Get ID 
    const id = window.location.hash.slice(1);
    if(!id) return recipeView.renderMessage();    
    
    // * Update Bookmarks
    bookMarksView.update(model.state.bookmarks);
    
    // * Update Search Results To Highlight Select Result
    resultsView.update(model.getPaginatedResults());

    // * Get Recipe 
    await model.getRecipe(id);

    // * Render Recipe 
    recipeView.render(model.state.recipe);
  } catch (error) {
    recipeView.renderError()
    console.log(error);
  }
  
};

const controlSearchResults= async function()
{
  try {
    // * Get Search Query
    const query = searchView.getQuery();
    if(!query) return;

    // * Render Loader
    resultsView.renderLoader();

    // * Fetch Results
    await model.loadSearchResults(query)

    // * Render Results
    resultsView.render(model.getPaginatedResults());

    // * Render Pagination
    paginationView.render(model.state.search);
  } catch (error) {
    console.log(error);
  }
}

const controlPage = function(page)
{
  // * Render Results
  resultsView.render(model.getPaginatedResults(page));

  // * Render Pagination
  paginationView.render(model.state.search);
  
}

const controlServings = function(newServings)
{
  // * Update Recipe Servings in state
  model.updateServings(newServings);
  // * Update Recipe in view
  recipeView.update(model.state.recipe);
}

const controlAddBookmark = function()
{
  if(!model.state.recipe.bookmarked)
  {
    model.addBookmark(model.state.recipe);
  }
  else
  {
    model.removeBookmark(model.state.recipe.id);
  }
  recipeView.update(model.state.recipe);
  bookMarksView.render(model.state.bookmarks);
}

const controlBookmarks = function()
{
  bookMarksView.render(model.state.bookmarks);
}

const controlAddRecipe = async function(newRecipe)
{
  try {
    addRecipeView.renderLoader();
    await model.uploadRecipe(newRecipe);
    recipeView.render(model.state.recipe);
    addRecipeView.renderMessage()
    window.history.pushState(null,"",`#${model.state.recipe.id}`);
    bookMarksView.render(model.state.bookmarks);
    // window.location.hash = model.state.recipe.id;
    setTimeout(()=>{
      addRecipeView.toggleWindow();
    },MODAL_CLOSE_SEC)
    setTimeout(()=>{
      addRecipeView.resetForm();
    },FORM_RESET_SEC)
  } catch (error) {
    console.log(error);
    addRecipeView.renderError(error.message);
  }
}
///////////////////////////////////////
init();